module.exports = __webpack_public_path__ + "693850ae08a0d087352392bd08a9c51f.png";